import type { CSSProperties, ReactElement } from 'react'
// react-syntax-highlighter は Light + registerLanguage の利用が公式パターンで、言語/style はサブパスから取り出します
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter'
import json from 'react-syntax-highlighter/dist/esm/languages/hljs/json'
import pgsql from 'react-syntax-highlighter/dist/esm/languages/hljs/pgsql'
import sql from 'react-syntax-highlighter/dist/esm/languages/hljs/sql'
import { monokaiSublime } from 'react-syntax-highlighter/dist/esm/styles/hljs'

SyntaxHighlighter.registerLanguage('json', json)
SyntaxHighlighter.registerLanguage('pgsql', pgsql)
SyntaxHighlighter.registerLanguage('sql', sql)

export type CodeHighlighterLanguage = 'json' | 'pgsql' | 'sql'

export const CodeHighlighter = ({
  language,
  children,
  customStyle,
  wrapLongLines,
}: {
  language: CodeHighlighterLanguage
  children: string
  customStyle?: CSSProperties
  wrapLongLines?: boolean
}): ReactElement => (
  <SyntaxHighlighter language={language} style={monokaiSublime} customStyle={customStyle} wrapLongLines={wrapLongLines}>
    {children}
  </SyntaxHighlighter>
)
